import { createRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { ApiError } from "../../shared/api/http.js";
import { Button, Card, Field, Input } from "../../shared/ui/index.js";
import { CenteredLayout } from "../../shared/ui/CenteredLayout.js";
import { useForgotPassword } from "./auth.api.js";
import { rootRoute } from "../../app/root-route.js";

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/forgot-password",
  validateSearch: (s: Record<string, unknown>): { email?: string } => ({
    email: typeof s.email === "string" ? s.email : undefined,
  }),
  component: ForgotPasswordScreen,
});

function ForgotPasswordScreen() {
  const search = forgotPasswordRoute.useSearch();
  const forgot = useForgotPassword();
  const [email, setEmail] = useState(search.email ?? "");

  return (
    <CenteredLayout>
      <Card>
        <h1 className="text-center font-serif text-2xl text-stone-900">Mot de passe oublié</h1>
        {forgot.isSuccess ? (
          <p className="mt-4 text-sm text-stone-600">
            Si un compte existe pour <strong>{email}</strong>, un email contenant un lien de
            réinitialisation vient d'être envoyé. Le lien est valable 1 heure.
          </p>
        ) : (
          <>
            <p className="mt-1 text-center text-sm text-stone-500">
              Saisissez votre email pour recevoir un lien de réinitialisation.
            </p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                forgot.mutate({ email });
              }}
              className="mt-6 flex flex-col gap-3"
            >
              <Field label="Email">
                <Input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Field>
              {forgot.error && (
                <p className="text-sm text-rose-600">
                  {forgot.error instanceof ApiError ? forgot.error.message : "Erreur"}
                </p>
              )}
              <Button type="submit" disabled={forgot.isPending}>
                {forgot.isPending ? "…" : "Envoyer le lien"}
              </Button>
            </form>
          </>
        )}
        <Link
          to="/login"
          className="mt-4 block text-center text-sm text-stone-500 underline-offset-2 hover:text-stone-800 hover:underline"
        >
          Retour à la connexion
        </Link>
      </Card>
    </CenteredLayout>
  );
}
